import { useAmp } from 'next/amp';

/**
 * AmpWrap is a function to Wrap components and validate if used on amp or not.
 * @param ampOnly
 * @param nonAmp
 * @returns {boolean|*}
 * @constructor
 */
const AmpWrap = ({ ampOnly, nonAmp }) => {
  const isAmp = useAmp();
  if (ampOnly) return isAmp && ampOnly;
  return !isAmp && nonAmp;
};

export default AmpWrap;
